<template>
  <span
    :class="[
      'px-2 py-1 text-xs font-medium rounded-full text-white',
      value ? 'bg-green-500' : 'bg-red-500'
    ]"
  >
    {{ value ? yes : no }}
  </span>
</template>

<script>
export default {
  name: "YesNoLabel",
  props: {
    value: {
      default: false
    },
    yes: {
      default: "Sí"
    },
    no: {
      default: "No"
    }
  }
};
</script>
